import { Item } from "dsabp-js"
import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { getImage, toImage } from "../util.js"

const infoMap = new Map([
	[Item.TURRET_REMOTE, {
		barrel: "turret_barrel",
		action: "turret_action",
		barrelPos: { x: 78, y: 40+9 },
		actionPos: { x: 36, y: 40+5 }
	}],
	[Item.TURRET_REMOTE_STARTER, {
		barrel: "turret_barrel",
		action: "turret_action_rc_starter",
		barrelPos: { x: 78, y: 40+9 },
		actionPos: { x: 20-6, y: 40+5-6 }
	}],
	[Item.TURRET_BURST, {
		barrel: "turret_barrel_burst",
		action: "turret_action_burst",
		barrelPos: { x: 78, y: 40+9 },
		actionPos: { x: 40-4, y: 10 },
	}],
	[Item.TURRET_AUTO, {
		barrel: "turret_barrel",
		action: "turret_action_auto",
		spinner: "turret_auto_spinner",
		barrelPos: { x: 78, y: 33 },
		actionPos: { x: 40-5, y: 40-10 },
		secondBarrelOffY: 10
	}],
	[Item.TURRET_ACUTE, {
		barrel: "turret_barrel_burst",
		action: "turret_action_acute",
		barrelPos: { x: 78, y: 40+9 },
		actionPos: { x: 20-10, y: 40+5 }
	}],
	[Item.TURRET_OBTUSE, {
		barrel: "turret_barrel_obtuse",
		action: "turret_action_obtuse",
		barrelPos: { x: 78, y: 40+6 },
		actionPos: { x: 40-12, y: 40-12 },
	}],
])

rendererResolvers.push(
	({ toRel, item }) => {
		const info = infoMap.get(item)
		if (!info) return

		return {
			discriminator: `${item.id}`,
			async render() {
				const imgBase = await getImage("turret_base")
				const imgBarrel = await getImage(info.barrel)
				const imgAction = await getImage(info.action)

				const canvas = createCanvas(190, imgBase.height)
				const ctx = canvas.getContext("2d")

				ctx.drawImage(imgBase, -40, 0)
				ctx.drawImage(imgBarrel, info.barrelPos.x, info.barrelPos.y)
				if (info.secondBarrelOffY != null)
					ctx.drawImage(imgBarrel, info.barrelPos.x, info.barrelPos.y + info.secondBarrelOffY + imgBarrel.height)
				ctx.drawImage(imgAction, info.actionPos.x, info.actionPos.y)
				if (info.spinner != null) {
					const imgSpinner = await getImage(info.spinner)
					ctx.drawImage(imgSpinner, info.actionPos.x, info.actionPos.y)
				}

				return [{
					image: await toImage(canvas),
					textureSizeOff: toRel(150, 0),
					baseBoundOff: { x: 0.2, y: 0.2 } // original bounds are 0.2 smaller
				}]
			}
		}
	}
)
